import { Box, Container, Skeleton, Stack, useTheme } from "@mui/material";
import React from "react";

export default function BannersSctSk() {
  const theme = useTheme();

  return (
    <Container maxWidth={"xxl"} sx={{ position: "relative" }}>
      <Stack
        direction={"row"}
        sx={{
          gap: "1rem",
          rowGap: "1rem",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        {/* Skeleton Item */}
        {[1, 2].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            sx={{
              width: "49%",
              height: "360px",
              borderRadius: "1.5rem",
            }}
          />
        ))}
      </Stack>

      {/* Circle Images left Center Skeleton */}
      <Box
        sx={{
          position: "absolute",
          bottom: "100%",
          left: "50%",
          transform: "translate(-40% , 70%)",
          zIndex: "-10",
          width: "350px",
          height: "350px",
          opacity: ".4",
        }}
      >
        <Skeleton
          variant="circular"
          sx={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </Container>
  );
}
